'use strict';

const getLocationHash = require('./getLocationHash');

/**
 * @function
 * @description Checks if the location hash has the String trigger in it
 * and returns it if it has. If not returns empty string
 */
const getTriggerFromHash = () => {
    const hash = getLocationHash(window.location.hash);
    return (hash.indexOf('trigger') === 0) ? hash : '';
};

module.exports = getTriggerFromHash;
